export const DATE_OF_PAYMENT_CONSTANT = 'Pago inmediato';
